<ng-container *ngIf="ai_differentiator_data_loaded">
    <div class="date-section">
      <span>Last Updated on </span>
      <span class="date-format">{{ ai_differentiator_data.last_updated }}</span>
    </div>
  
    <div class="ai-section">
      <div style="display: flex; flex-direction: row; align-items: center">
        <div class="ai-clients-section">
          <div>
            <div class="ai-clients-image-section">
              <img src="assets/portfolio-total-clients.svg" />
            </div>
            <span class="date-format">{{ ai_differentiator_data.clients }} </span>
            <span>Clients </span>
          </div>
          <div class="horizontal-connector"></div>
        </div>
        <div class="horizontal-connector"></div>
      </div>
      <div class="vertical-connector"></div>
      <div class="ai-tasks-section">
        <div class="each-ai-task-section">
          <div class="horizontal-small-connector"></div>
          <div class="each-ai-tasks-details-section" style="align-items: center;">
            <div class="each-ai-tasks-detail-image-section">
              <img src="assets/automation.png" />
              <p>Automated Activities</p>
            </div>
            <div class="each-ai-tasks-detail-tasks-section">
              <div
                class="each-result-section"
                *ngFor="let activity of ai_differentiator_data.activities"
              >
                <div class="each-result-pointer"></div>
                <span class="each-result-point">{{ activity }}</span>
              </div>
              <!-- <div
                class="each-ai-tasks-detail-activities"
                *ngFor="let activity of ai_differentiator_data.activities"
              >
                <div class="each-ai-name-section">
                  <span>{{ activity.name }}</span>
                </div>
                <div class="each-ai-description-section">
                  <p>{{ activity.value }}</p>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="each-ai-task-section">
          <div class="horizontal-small-connector"></div>
          <div class="each-ai-tasks-details-section">
            <div class="each-ai-tasks-detail-image-section">
              <img src="assets/data-science.png" />
              <p>AI-Self Learning Insights</p>
            </div>
            <div class="each-ai-tasks-detail-tasks-section">
              <!-- <div class="each-ai-tasks-detail-activities" *ngFor="let insight of ai_differentiator_data.insights">
                              <div class="each-ai-name-section">
                                  <span>{{insight.name}}</span>
                              </div>
                              <div class="each-ai-description-section">
                                  <p>{{insight.value}}</p>
                                  <p class="each-ai-secondary-description" *ngIf="insight.description != '' && insight.description != null">{{insight.description}}</p>
                              </div>
                          </div> -->
              <div class="each-ai-tasks-detail-activities">
                <div class="each-ai-name-section">
                  <span>Q4 2023</span>
                </div>
                <div class="each-ai-description-section">
                  <p>Model Updated</p>
                  <p class="each-ai-secondary-description">Shorter Sales Cycle</p>
                </div>
              </div>
              <div class="each-ai-tasks-detail-activities">
                <div class="each-ai-name-section">
                  <span>Q3 2023</span>
                </div>
                <div class="each-ai-description-section">
                  <p>No updates to Model</p>
                  <p class="each-ai-secondary-description">
                    2022 Advisor Sales Activities | refined my activity list
                  </p>
                </div>
              </div>
              <div class="each-ai-tasks-detail-activities">
                <div class="each-ai-name-section">
                  <span>Q2 2023</span>
                </div>
                <div class="each-ai-description-section">
                  <p>Model Updated</p>
                </div>
              </div>
              <div class="each-ai-tasks-detail-activities">
                <div class="each-ai-name-section">
                  <span>Q2 2023</span>
                </div>
                <div class="each-ai-description-section">
                  <p>Model refreshed with 2021 data</p>
                  <p class="each-ai-secondary-description">
                    Learned from advisor sales activities.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="each-ai-task-section">
          <div class="horizontal-small-connector"></div>
          <div class="each-ai-tasks-details-section" style="bottom: -24px; align-items: center;">
            <div class="each-ai-tasks-detail-image-section">
              <img src="assets/artificial-intelligence.png" />
              <p>Results</p>
            </div>
            <div class="each-ai-tasks-detail-tasks-section">
              <div
                class="each-result-section"
                *ngFor="let result of ai_differentiator_data.results"
              >
                <div class="each-result-pointer"></div>
                <span class="each-result-point">{{ result }}</span>
              </div>
              <!-- <div class="each-result-section">
                              <div class="each-result-pointer"></div>
                              <span class="each-result-point">Executed all activities required for Cross-Sell opportunities</span>
                          </div>
                          <div class="each-result-section">
                              <div class="each-result-pointer"></div>
                              <span class="each-result-point">Forwarded to lead advisors</span>
                          </div>
                          <div class="each-result-section">
                              <div class="each-result-pointer"></div>
                              <span class="each-result-point">Clients Attrition Risk - 9</span>
                          </div>
                          <div class="each-result-section">
                              <div class="each-result-pointer"></div>
                              <span class="each-result-point">Executed all activities required for Clients Attrition Risk</span>
                          </div>
                          <div class="each-result-section">
                              <div class="each-result-pointer"></div>
                              <span class="each-result-point">Advisors Intimated - Port Miller & Advisor 2</span>
                          </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  
  <ng-container *ngIf="!ai_differentiator_data_loaded">
    <app-loader [loading_text]="'Loading AI Differentiator Data'"></app-loader>
  </ng-container>
  